

export class Configuration {

  public static loginUrl = 'login';
  public static homeUrl = 'home';
  public static newPath = 'new';
  public static editPath = 'edit';

  public static passwordRegExPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$^+=¡!*()@%&]).{6,}$/;

  public static rolAdministrador = 'Admin';
  public static rolUsuario = 'User';
  public static proyectName = 'Lives HR';

}
